import { create } from "zustand";

export const useLang = create((set) => ({
  ur: false,
  toggle: () => set((s) => ({ ur: !s.ur })),
}));
